import {Injectable, NgZone} from '@angular/core';
import { Action, State, StateContext, StateToken, Selector, Store } from '@ngxs/store';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {AuthState} from "./auth.state";
import {Bank, UserBank} from "../models/bank.model";
import {Observable, throwError} from "rxjs";
import {TipoCheque} from "../models/cheque.model";
import {BankApiService} from "../api/bank-api.service";
import {CreateUserBankAction, DeleteUserBankAction, GetUserBankListAction, SetFavoriteUserBankAction} from "../actions/bank.actions";

export interface UserBankStateModel {
  bankList:UserBank[],
  bank:UserBank
}

const initialState: UserBankStateModel = {
  bankList:null,
  bank:null
};

const BANK_STATE_TOKEN = new StateToken<UserBankStateModel>('bank');

@State<UserBankStateModel>({
  name: BANK_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class UserBankState {

  constructor(
    private store: Store,
    private bankApiService:BankApiService
  ) {}

  @Action(GetUserBankListAction)
  handleGetBankListAction(ctx: StateContext<UserBankStateModel>) {

    ctx.patchState({
      bankList:null
    })

    return this.bankApiService.getUserBankList().pipe(
      tap(bankList => {
        const state = ctx.getState();

        ctx.patchState({
          bankList
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(CreateUserBankAction)
  handleCreateUserBankAction(ctx: StateContext<UserBankStateModel>, action:CreateUserBankAction) {

    const bank = action.payload;

    ctx.patchState({
      bank:null
    })

    return this.bankApiService.createUserBank(bank).pipe(
      tap(createdBank => {
        const state = ctx.getState();

        ctx.patchState({
          bank:createdBank,
          bankList:[state?.bankList,createdBank]
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(SetFavoriteUserBankAction)
  handleSetFavoriteUserBankAction(ctx: StateContext<UserBankStateModel>, action:SetFavoriteUserBankAction) {

    const bank = action.payload;

    ctx.patchState({
      bank:null
    })

    return this.bankApiService.setFavoriteUserBank(bank).pipe(
      tap(createdBank => {
        const state = ctx.getState();

        ctx.patchState({
          bank:createdBank,
          bankList:[state?.bankList,createdBank]
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(DeleteUserBankAction)
  handleDeleteUserBankAction(ctx: StateContext<UserBankStateModel>, action:DeleteUserBankAction) {

    const bank = action.payload;

    ctx.patchState({
      bank:null
    })

    return this.bankApiService.deleteUserBank(bank.id).pipe(

      switchMap(deleteResponse => {
        return ctx.dispatch(new GetUserBankListAction())
      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }



  @Selector()
  static getBankList(state: UserBankStateModel) {
    return state?.bankList
  }
}
